<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb
      :title="page.title"
      :icon="page.icon"
      :breadcrumbs="breadcrumbs"
    ></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <LiveEventList></LiveEventList>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "LiveEvents",
  data: () => ({
    page: {
      title: "Live Events"
    },
    elementVisible: false,
    breadcrumbs: [
      {
        text: "Live Events",
        disabled: true
      }
    ]
  }),
  components: {
    LiveEventList: () => import("../components/LiveEventList")
  }
};
</script>
